module.exports = __webpack_public_path__ + "img/11.db1ab21b.jpg";